import React from "react";
const Homepage = React.lazy(() => import("../views/home/Home"));
const ProductDeatil = React.lazy(
  () => import("../views/productdetails/ProductDetails"),
);
const Blog = React.lazy(() => import("../views/blog/Blog"));
const CareerDetail = React.lazy(() => import("../views/careers/CareerDetail"));
const TermsAndCondition = React.lazy(
  () => import("../views/terms/TermsAndCondition"),
);
const RefundAndReturn = React.lazy(
  () => import("../views/terms/RefundAndReturn"),
);
const Enquiry = React.lazy(() => import("../views/terms/Enquiry"));
const MarketArea = React.lazy(() => import("../views/terms/MarketArea"));
const CustmerReview = React.lazy(() => import("../views/terms/CustomerReview"));
const Aboutus = React.lazy(() => import("../views/aboutus/AboutUs"));
const Career = React.lazy(() => import("../views/careers/Career"));
const Contectus = React.lazy(() => import("../views/contactus/ContactUs"));
const Faq = React.lazy(() => import("../views/faq/Faq"));
const PrivacyPolicy = React.lazy(
  () => import("../views/privacypolicy/PrivancyPolicy"),
);
const TrackOrder = React.lazy(() => import("../views/trackorder/TrackOrder"));
const Franchise = React.lazy(() => import("../views/franchise/Franchise"));
const DynamicRouteHandler = React.lazy(() => import("./DynamicRouteHandler"));
const CampaignEnquiry = React.lazy(
  () => import("../views/campaign-enquiry/CampaignEnquiry"),
);

export const RouteData = [
  {
    path: "/enquiry-Saree",
    element: <CampaignEnquiry />,
  },
  {
    path: "/enquiry-Kurti",
    element: <CampaignEnquiry />,
  },
  {
    path: "/enquiry-suit",
    element: <CampaignEnquiry />,
  },
  {
    path: "/enquiry-lehenga",
    element: <CampaignEnquiry />,
  },
  {
    path: "/enquiry-mens",
    element: <CampaignEnquiry />,
  },
  {
    path: "/enquiry-kids",
    element: <CampaignEnquiry />,
  },
  {
    path: "/enquiry-night",
    element: <CampaignEnquiry />,
  },
  {
    path: "/enquiry-clothing",
    element: <CampaignEnquiry />,
  },
  {
    path: "/:slug/",
    element: <DynamicRouteHandler />,
  },
  {
    path: "/:cityName/:slug",
    element: <DynamicRouteHandler />,
  },
  {
    path: `/`,
    element: <Homepage />,
  },
  {
    path: "/about",
    element: <Aboutus />,
  },
  {
    path: "/clothing-franchise",
    element: <Franchise />,
  },
  {
    path: "/career",
    element: <Career />,
  },
  {
    path: "/contact-us",
    element: <Contectus />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms-condition",
    element: <TermsAndCondition />,
  },
  {
    path: "/return-policy",
    element: <RefundAndReturn />,
  },
  {
    path: "/enquiry-ktc",
    element: <Enquiry />,
  },
  {
    path: "/enquiry-ktc/:name",
    element: <Enquiry />,
  },
  {
    path: "/market-area",
    element: <MarketArea />,
  },
  {
    path: "/customer-review",
    element: <CustmerReview />,
  },
  {
    path: "/track-your-delivery",
    element: <TrackOrder />,
  },
  {
    path: "/career/:id",
    element: <CareerDetail />,
  },
  {
    path: "/faq",
    element: <Faq />,
  },
  {
    path: "/blog",
    element: <Blog />,
  },
  {
    path: "/productdetail",
    element: <ProductDeatil />,
  },
  {
    path: "/blog/:categoryname",
    element: <Blog />,
  },
];
